import { ShieldAlert } from "lucide-react";

export const NotFound = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="text-center space-y-3">
        <ShieldAlert className="mx-auto h-12 w-12 text-destructive" />
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-lg text-gray-600">Página no encontrada</p>
      </div>
    </div>
  )
}
  